import { render } from "./EditExtract.vue?vue&type=template&id=fa66d738&scoped=true"
import script from "./EditExtract.vue?vue&type=script&lang=js"
export * from "./EditExtract.vue?vue&type=script&lang=js"

import "./EditExtract.vue?vue&type=style&index=0&id=fa66d738&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa66d738"]])

export default __exports__